import { render, staticRenderFns } from "./punchModal.vue?vue&type=template&id=560f2995&scoped=true"
import script from "./punchModal.vue?vue&type=script&lang=js"
export * from "./punchModal.vue?vue&type=script&lang=js"
import style0 from "./punchModal.vue?vue&type=style&index=0&id=560f2995&prod&lang=scss"
import style1 from "./punchModal.vue?vue&type=style&index=1&id=560f2995&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560f2995",
  null
  
)

export default component.exports